<div class="body ui container" fxLayout="column">

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <span class="ui grey">Home / eWallet / {{activeCurrency?.currencyShortName | titlecase}} eWallet</span>
        <h2 class="ui primary header">Withdrawal Requests</h2>
      </div>
    </div>
  </div>

<div class="ui divider"></div>


  <div class="ui grid" style="padding-top: 16px !important;">
    <div class="four wide column" style="padding: 0; padding-left: 14px; padding-right: 16px;">
      <app-account-sidebar></app-account-sidebar>
    </div>

    <div class="twelve wide column" style="padding: 0 !important;">

      <div *ngIf="success || error" appMargin marginB="10px">
        <esl-message-toast [(message)]="error"></esl-message-toast>
        <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      </div>

      <app-advanced-search-filter
          (onDisplayRows)="displayRecords($event)"
          (onSearch)="searchRecords($event)"
          [hasAdvancedSearch]="true"
          [headers]="headers"
          [hasFilters]="true"
          (onSort)="sortRecords($event)"
          [searchFilters]="searchFilter"
          (advancedSearch)="advancedSearch($event)"
          (cancelAd)="cancelAd()"
        ></app-advanced-search-filter>

          <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
            <div fxLayout="row" tamsyMargin class="ui segment" marginB="3" fxLayoutGap="15px" fxLayoutAlign="center center" style="height: 36px;"
              id="dark" appPadding paddingX="40px">
              <!-- <div fxFlex="18">Withdrawal Request ID</div> -->
              <div fxFlex="23">Transaction ID</div>
              <div fxFlex="13">Amount</div>
              <div fxFlex="13">Charges</div>
              <div fxFlex="13">Status</div>
              <div fxFlex="23">Transaction Date</div>
              <div fxFlex="6">Chat</div>
              <div fxFlex="12"></div>
            </div>

            <app-withdrawal-request-row
            [request]="request"
            [currencyCode]= "currencyCode"
            *ngFor="let request of requests"
            (onCancel)="cancelRequest(request)"
            ></app-withdrawal-request-row>

          </div>
      <div class="empty" *ngIf="requests && requests.length < 1">
        <img src="assets/images/wallet.png" alt="">
        <h3 class="mt-26 mb-0">
          This section does not contain any data.
        </h3>
        <h3 class="mb-24 mt-0">
          Your eWallet requests are displayed here
        </h3>

        <!-- <p class="my-0">
          Deposit funds into your eWallet to commence utilizing the
        </p>
        <p class="my-0">
          eWallet payment option for requests.
        </p>

        <button class="ui small button primary my-24" (click)="fundWallet()">
          Fund eWallet
        </button> -->
      </div>


      <!-- Pagination -->
      <div class="ui vertical basic segment">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui medium labeled button">
              <div class="records-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 1C13.866 1 17 2.79086 17 5C17 7.20914 13.866 9 10 9C6.13401 9 3 7.20914 3 5C3 2.79086 6.13401 1 10 1ZM15.694 9.13079C16.1576 8.86588 16.6044 8.54736 17 8.17775V10C17 12.2091 13.866 14 10 14C6.13401 14 3 12.2091 3 10V8.17775C3.3956 8.54736 3.84244 8.86588 4.30604 9.13079C5.83803 10.0062 7.85433 10.5 10 10.5C12.1457 10.5 14.162 10.0062 15.694 9.13079ZM3 13.1777V15C3 17.2091 6.13401 19 10 19C13.866 19 17 17.2091 17 15V13.1777C16.6044 13.5474 16.1576 13.8659 15.694 14.1308C14.162 15.0062 12.1457 15.5 10 15.5C7.85433 15.5 5.83803 15.0062 4.30604 14.1308C3.84244 13.8659 3.3956 13.5474 3 13.1777Z"
                    fill="#86879D"
                  />
                </svg>
              </div>
              <a class="ui basic label records-text">{{ totalItems }} Record(s)</a>
            </div>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="small"
              [collectionSize]="totalItems"
              [pageSize]="rows"
              [maxSize]="maxSize"
              [hasEllipses]="false"
              [page]="currentPage"
              (pageChange)="nextPage($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
